import { useEffect, useRef } from "react";
import cn from "classnames";
import styles from "./Preloader.module.scss";

type PreloaderProps = {
  preloaderWrapClassName?: string;
  className?: string;
  width?: number;
  height?: number;
};

const Preloader: RFC<PreloaderProps> = ({ preloaderWrapClassName, className, width = 50, height = 50 }) => {
  const spinnerRef = useRef<HTMLDivElement>(null);

  const spinnerStyle = {
    width: `${width}px`,
    height: `${height}px`,
  };

  useEffect(() => {
    if (spinnerRef.current) {
      const containerWidth = spinnerRef.current.clientWidth;
      const scale = containerWidth / 100;
      const ldioElement = spinnerRef.current.querySelector(`.${styles.ldio}`) as HTMLElement;

      if (ldioElement) {
        ldioElement.style.transform = `translateZ(0) scale(${scale})`;
      }
    }
  }, [width, height]);

  return (
    <div className={cn(styles.preloaderWrap, preloaderWrapClassName)}>
      <div className={cn(styles.loadingioSpinnerSpin, className)} style={spinnerStyle} ref={spinnerRef}>
        <div className={styles.ldio}>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Preloader };
